<template lang="html">
  <div class="col-lg-9 col-page-content page-style-1">

    <div class="row mt-0 box-candidates">

      <!-- Últimos perfiles guardados -->
      <div class="col-12 mt-0 col-candidates-list">
        <div class="row">

          <div class="col-12 mt-0 mb-4 box-acc-title-s1">
            <h4>Editar vacantes</h4>
            <hr />
          </div>

          <!-- Resultados -->
          <div class="col-12 col-jobs-s4" v-for="(job, hjbInx) in vacancies" :key="'hjbInx-'+hjbInx">
            <div class="box">
              <div class="box-urgent" v-if="job.urgente_regular == 'urgente'"><span>URGENTE</span></div>
              <div class="box-urgent" v-else-if="job.urgente_regular == 'regular'" style="background-color:#0e447b"><span>REGULAR</span></div>

              <div class="col col-logo">
                <img :src="job.empresa_imageUrl">
              </div>

              <div class="col col-info">
                <h4 class="title">{{job.nombre}}</h4>
                <h5><span class="company">
                  {{job.empresa}}</span><br />
                  <i class="loc-icon"></i><span class="location">{{job.estado}},{{job.ciudad}}.</span>
                </h5>
                <h5 class="extra">Publicado hace {{job.hace_dias}} días. | {{job.are}}</h5>
              </div>

              <div class="col-12 col-line">
                <hr />
              </div>

              <div class="col col-salary">
                <p>{{job.sueldo}} / {{job.periodo}}</p>
              </div>

              <div class="col col-buttons">
                <router-link class="btn _btn cand" :to="'/cuenta-empresa/candidatos/'+job.id">
                  <span class="icon"><i class="trans-150 fas fa-user-friends"></i></span>
                  <span class="txt">Candidatos</span>
                </router-link>

                <router-link class="btn _btn edit" :to="'/cuenta-empresa/publicar-vacante/'+job.id">
                  <span class="icon"><i class="trans-150 fas fa-pen"></i></span>
                  <span class="txt">Editar</span>
                </router-link>

                <button class="btn _btn del" @click="deleteVacant(job.id)">
                  <span class="icon"><i class="trans-250 far fa-trash-alt"></i></span>
                  <span class="txt">Eliminar</span>
                </button>
              </div>
            </div>
          </div>
          <!--  -->

          <!--div class="col-12">
            <div class="row pagination-container">
              <div class="col-12 col-pagination">
                <b-pagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  aria-controls="my-table"
                ></b-pagination>
              </div>
            </div>
          </div-->

        </div>
      </div>
      <!--  -->

    </div>
    <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
      </sweet-modal>
      <sweet-modal ref="modalAlert" :icon="modal.icon">
          <p>{{modal.msg}}</p>
           <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
      </sweet-modal>

  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
export default {
  data(){
    return{
      pagination:{
        current_page:1,
        order:0,
        per_page:10,
      },
      vacancies:[],
      modal:{
          icon:null,
          msg:null
      }
    }
  },
  
  methods: {
      
      getVacancies(){
          axios.get(tools.url("/api/admin/myvacancies")).then((response)=>{
              this.vacancies=response.data;
          }).catch((error)=>{
          });
      },
      deleteVacant(id){
          var r = confirm("¿Esta seguro de eliminar esta vacante?");
          if (r == true) {
              axios.delete(tools.url("/api/admin/vacancies/"+id))
              .then((response)=>{
                  this.modal.icon = 'success';
                  this.modal.msg = 'Vacante eliminada correctamente';
                  this.$refs.modalAlert.open();
                  this.getVacancies();
              })
              .catch((error)=>{
                  this.modal.icon = 'error';
                  this.modal.msg = 'Ocurrio un error al guardar la información';
                  this.$refs.modalAlert.open();
              });
          }
      }
  },
  mounted(){
      this.getVacancies();
     
  },

  components: {
    'editor': Editor
  },
}
</script>
